import React from 'react'

export const Pageloader = () => {
    return (
        <div className="text-center" >
        <div className="spinner-grow preloaderCOLOR1" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
        <div className="spinner-grow preloaderCOLOR2" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
    )
}
